import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';

import shapeImg1 from '../../assets/img/contact/ct-shape-1.png';
import shapeImg2 from '../../assets/img/contact/ct-shape-2.png';
import shapeImg3 from '../../assets/img/contact/ct-shape-3.png';
import shapeImg4 from '../../assets/img/contact/ct-shape-4.png';

const ContactTwo = (props) => {
  const { itemClass } = props;
  const formRef = useRef();
  const [formData, setFormData] = useState({ name: '', mobile: '', email: '', message: '' });

  // Validate form fields
  const validateForm = () => {
    const { name, email, message, mobile } = formData;
    if (!name || !email || !message || !mobile) {
      toast.error("All fields are required.");
      return false;
    }
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email.");
      return false;
    }
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(mobile)) {
      toast.error("Enter a valid 10-digit mobile number.");
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        {
          publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
        }
      )
      .then(
        () => {
          toast.success("Message sent successfully!");
          formRef.current.reset();
          setFormData({ name: '', email: '', mobile: '', message: '' });
          console.log('SUCCESS!');
        },
        (error) => {
          console.error('FAILED...', error);
          toast.error("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'contact__area contact__plr-2 mt-100 mb-100 p-relative fix'
      }
    >
      <div className="contact__shape-1 d-none d-lg-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="contact__shape-2 d-none d-md-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="contact__shape-3 d-none d-md-block">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="contact__shape-4 d-none d-md-block">
        <img src={shapeImg4} alt="" />
      </div>
      <div className="contact__border">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-8 col-lg-7">
              <div className="contact__section-title pb-10">
                <h4 className="section-subtitle char-anim">Contact Us</h4>
                <h3 className="section-title char-anim">
                  Feel free to get in touch <br />
                </h3>
              </div>
              <div className="contact__text">
                <p className="char-anim-2">
                  We’re here to help, build, and grow — together.<br />
                  Whether you have a brilliant idea, a question, or just want to say hello — let’s connect!<br />
                  Our team is always ready to collaborate, solve, and support.{' '}
                </p>
              </div>
              <div
                className="contact__form wow animate__fadeInUp"
                data-wow-duration="1.1s"
              >
                <form ref={formRef} onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="postbox__contact-input">
                        <input type="text" name="name" value={formData.name}
                          onChange={handleChange} placeholder="Your Name" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="postbox__contact-input">
                        <input type="tel" name="mobile" value={formData.mobile}
                          onChange={handleChange} placeholder="Your Mobile" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="postbox__contact-input">
                        <input type="email" name="email" value={formData.email}
                          onChange={handleChange} placeholder="Your Email" />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="postbox__contact-textarea">
                        <textarea placeholder="Message" name="message" rows="4"
                          value={formData.message}
                          onChange={handleChange}></textarea>
                      </div>
                    </div>
                    <div
                      className="contact__button wow animate__fadeInUp"
                      data-wow-duration="1.1s"
                    >
                      <button className="main-btn-sm  tp-btn-hover alt-color" type="submit">Send Message</button>
                    </div>
                  </div>
                </form>
                {/* Toast Container */}
                <ToastContainer position="top-center" autoClose={3000} />
              </div>

            </div>
            <div className="col-xl-4 col-lg-5">
              <div className="contact__left-side">
                <div
                  className="contact__item d-flex align-items-center wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <div className="contact__icon">
                    <span>
                      <a href="#">
                        <i className="fal fa-phone-alt"></i>
                      </a>
                    </span>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm">Phone</h4>
                    <span>
                      {/*<a href="tel:+91-9096781543">+91-9096781543</a><br />*/}
                      <a href="tel:+91-9500141809">+91-9500141809</a>
                    </span>
                  </div>
                </div>
                <div
                  className="contact__item d-flex align-items-center wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <div className="contact__icon">
                    <span>
                      <a href="#">
                        <i className="fal fa-envelope-open-text"></i>
                      </a>
                    </span>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm">Email</h4>
                    <span>
                      <a href="mailto:info@tgvctechnologies.in">
                        info@tgvctechnologies.in
                      </a>
                    </span>
                  </div>
                </div>
                <div
                  className="contact__item d-flex align-items-center wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <div className="contact__icon">
                    <span>
                      <a href="#">
                        <i className="fal fa-map-marker-check"></i>
                      </a>
                    </span>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm">Address</h4>
                    <span>
                      Brundavan Colony, Aditya Nagar, Gurram Guda,<br />
                      Nadargul, Hyderabad, Telangana - 501510.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactTwo;
